import { INITIAL_PLAYER_Y } from '../logic/gameUtils';
import getPlayfieldPosition from './playfieldPosition';
import './PlayerShip.css';

function PlayerShip({
  isShielded,
  lean = 'center',
  playerX,
  playerY = INITIAL_PLAYER_Y,
  selectedPlayableIcon = 'shooter',
}) {
  const playerClassName = [
    'player-ship',
    `player-ship-${selectedPlayableIcon}`,
    `player-lean-${lean}`,
    isShielded ? 'player-shielded' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={playerClassName}
      style={getPlayfieldPosition(playerX, playerY)}
      aria-hidden="true"
    >
      <img src={`${process.env.PUBLIC_URL}/player-ship.png`} alt="" />
    </div>
  );
}

export default PlayerShip;
